import React from 'react'
import styles from './ActionGuideWithBackground.module.scss'
import { Button } from 'spa/member/components/v2/Button'
import { ActionGuideWithBackgroundProps } from './types'

export const StyledActionGuideWithBackground: React.FC<ActionGuideWithBackgroundProps> = props => {
  return (
    <div className={`flex flex-col items-center text-center w-full rounded-L px-XL py-3XL text-member-gray-0 relative tablet:p-5XL ${styles.actionGuide} ${props.className || ''}`}>
      <h2 className={`text-XL font-bold pb-S whitespace-pre-wrap tablet:text-4XL ${props.headerClassName || ''}`}>{props.title}</h2>
      <p className="text-S tablet:text-M font-bold whitespace-pre-wrap" style={{ lineHeight: '1.75' }}>
        {props.description}
      </p>
      <div className="flex justify-center w-full mt-XL tablet:mt-2XL">
        <a href="/signup">
          <Button kind="danger" className={`all:w-full tablet:w-80 ${styles.button}`} link>無料登録する</Button>
        </a>
      </div>
      <img src={props.image} className={`absolute hidden tablet:block ${props.imageClassName || ''}`} width={props.imageWidth} />
    </div>
  )
}
